import { render } from "./PaperTable.vue?vue&type=template&id=28e6842e&scoped=true"
import script from "./PaperTable.vue?vue&type=script&lang=js"
export * from "./PaperTable.vue?vue&type=script&lang=js"

import "./PaperTable.vue?vue&type=style&index=0&id=28e6842e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e6842e"]])

export default __exports__